import { useTranslation } from 'react-i18next';
interface PreviewMediaProps {
  mediaUrl: string;
  mediaType: 'image' | 'video' | undefined;
  className?: string;
}

export const PreviewMedia = ({ mediaUrl, mediaType, className }: PreviewMediaProps) => {
  const { t } = useTranslation('contentTest');

  if (mediaType === 'video') {
    return (
      <video
        src={mediaUrl}
        muted
        playsInline
        loop
        autoPlay
        data-testid="phone-preview-media"
        className={className}
      />
    );
  }
  return (
    <img
      src={mediaUrl}
      alt={t('contentTest.previewMedia.contentMedia')}
      data-testid="phone-preview-media"
      className={className}
    />
  );
};

PreviewMedia.displayName = 'PreviewMedia';
